import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchPatientId: "",
  recordId: "",
  patientId: "",
  birthDate: null,
  gender: "",
  birthZipCode: "",
  residentialZipCode: "",
  comments: "",
  patientData: null,
  symptoms: [],
  diseases: [],
  familyBackgrounds: [],
  patientBackgrounds: [],
  diagnosis: [],
};

export const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    storeSearchPatientIdActionCreator: (state, action) => {
      state.searchPatientId = action.payload;
    },
    storeRecordIdActionCreator: (state, action) => {
      state.recordId = action.payload;
    },
    storePatientIdActionCreator: (state, action) => {
      state.patientId = action.payload;
    },
    storeBirthDateActionCreator: (state, action) => {
      state.birthDate = action.payload;
    },
    storeGenderActionCreator: (state, action) => {
      state.gender = action.payload;
    },
    storeBirthZipCodeActionCreator: (state, action) => {
      state.birthZipCode = action.payload;
    },
    storeResidentialZipCodeActionCreator: (state, action) => {
      state.residentialZipCode = action.payload;
    },
    storeCommentsActionCreator: (state, action) => {
      state.comments = action.payload;
    },
    storePatientDataActionCreator: (state, action) => {
      state.patientData = action.payload;
    },
    storePatientSymptomsActionCreator: (state, action) => {
      state.symptoms = action.payload;
    },
    storePatientDiseasesActionCreator: (state, action) => {
      state.diseases = action.payload;
    },
    storeFamilyBackgroundsActionCreator: (state, action) => {
      state.familyBackgrounds = action.payload;
    },
    storePatientBackgroundsActionCreator: (state, action) => {
      state.patientBackgrounds = action.payload;
    },
    storePatientDiagnosisActionCreator: (state, action) => {
      state.diagnosis = action.payload;
    },
    storePatientInitialStateActionCreator: () => {
      return initialState;
    },
    storePatientInfoAction: (state, action) => {
      state.recordId = action.payload?.id || "";
      state.patientId = action.payload?.patient_id || "";
      state.gender = action.payload?.gender || "";
      state.birthDate = action.payload?.birth_date || null;
      state.residentialZipCode = action.payload?.residential_zip_code || "";
      state.birthZipCode = action.payload?.birth_zip_code || "";
      state.comments = action.payload?.comments || "";
    },
  },
});

export const {
  storeRecordIdActionCreator,
  storePatientIdActionCreator,
  storeBirthDateActionCreator,
  storeGenderActionCreator,
  storeBirthZipCodeActionCreator,
  storeResidentialZipCodeActionCreator,
  storeCommentsActionCreator,
  storePatientDataActionCreator,
  storePatientSymptomsActionCreator,
  storePatientDiseasesActionCreator,
  storeFamilyBackgroundsActionCreator,
  storePatientBackgroundsActionCreator,
  storePatientDiagnosisActionCreator,
  storePatientInitialStateActionCreator,
  storeSearchPatientIdActionCreator,
  storePatientInfoAction,
} = patientSlice.actions;

export const {
  recordId,
  patientId,
  birthDate,
  gender,
  birthZipCode,
  residentialZipCode,
  comments,
  patientData,
  symptoms,
  diseases,
  familyBackgrounds,
  patientBackgrounds,
  diagnosis,
  searchPatientId,
} = patientSlice.reducer;

export default patientSlice.reducer;
